<template>
  <div>
    <v-sheet style="padding-bottom: 80px; position: relative">
      <v-sheet min-height="200">
        <!-- Premium Concept Description -->
        <PremiumConceptDesc v-if="concept" :concept="concept" :key="'premium-desc-' + componentKey" />

        <v-card flat class="px-0 py-4" v-if="options.content">
          <TipTapReader class="tiptap_style" :options="options" v-if="options.content" :key="componentKey" />
          <!-- <div v-else class="text-center font-weight-medium">입력 정보가 없습니다.</div> -->
        </v-card>
        <HtmlReader v-if="productType" :id="productType === 'premium' ? 'common-premium-desc' : 'common-desc'" :key="productType"></HtmlReader>
      </v-sheet>

      <!-- title -->
      <v-sheet>
        <div style="position: relative">
          <p class="text-center text-subtitle-1 text-md-h6 font-weight-medium title">{{ $t("page.conceptbooth.review-title") }}</p>
          <v-btn class="reviewBtn" style="position: absolute; bottom: 10px; right: 10px" small depressed @click="show_warning_dialog = true">{{ $t("button.review-write") }}</v-btn>
        </div>
        <div class="mt-1">
          <ReviewList :conceptId="$route.params.conceptId" />
        </div>
      </v-sheet>

      <!-- <v-tabs v-model="tabs" color="primary" fixed-tabs class="mt-1">
        <v-tab v-for="item in tabItems" :key="item" class="text-subtitle-1 font-weight-medium">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <ReviewList :conceptId="$route.params.conceptId" />
        </v-tab-item>
        <v-tab-item>
          <HtmlReader id="castle-concept-qna" />
        </v-tab-item>
      </v-tabs-items> -->
    </v-sheet>
    <ReviewWriteMoveGuideDialog @input="(e) => (show_warning_dialog = e)" @close="show_warning_dialog = false" @confirm="albumMove" :visible="show_warning_dialog" />

    <!-- Floating 예약하기 버튼 -->
    <v-btn fixed bottom right color="primary" large class="floating-reserve-btn" rounded elevation="6" @click="goReserve">
      <v-icon left>mdi-calendar-check</v-icon>
      예약하기
    </v-btn>
  </div>
</template>
<script>
import HtmlReader from "./components/HtmlReader"
import TipTapReader from "@/components/tiptap/Reader"
import ReviewList from "@/views/review/ReviewList"
import ReviewWriteMoveGuideDialog from "@/views/components/ReviewWriteMoveGuideDialog"
import PremiumConceptDesc from "./components/PremiumConceptDesc"
import htmlServce from "@/api/html-service"
import { mapState } from "vuex"

export default {
  components: {
    HtmlReader,
    TipTapReader,
    ReviewList,
    ReviewWriteMoveGuideDialog,
    PremiumConceptDesc,
  },

  data: () => ({
    show_warning_dialog: false,
    tabs: null,
    tabItems: ["공주들의 촬영" /*, "컨셉부스 QNA" */],

    concept: {},
    productType: null,

    //TipTap
    options: {
      content: "",
      readonly: true,
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,
  }),

  computed: {
    ...mapState(["lang"]),
  },

  watch: {
    lang: function (val) {
      this.options.content = this.getContent()
      this.componentKey += 1
    },
  },

  mounted() {
    console.log(this.$route.params.conceptId)
    this.load()
  },
  methods: {
    load() {
      console.log("conceptId: " + this.$route.params.conceptId)
      this.$http
        .post("/api/concept/select/specific", {
          params: {
            id: this.$route.params.conceptId,
          },
        })
        .then((res) => {
          this.concept = res.data[0]
          this.productType = this.concept.productType || "makershot"
          console.log("productType: " + this.productType)
          this.options.content = this.getContent()
          this.componentKey += 1
          //this.options.content = res.data[0].content
        })
    },

    albumMove() {
      this.show_warning_dialog = false
      this.$router.push("/mypage/home?type=picture")
    },

    getContent() {
      if (!this.concept) {
        return ""
      }

      switch (this.lang) {
        case "jp":
          return this.concept.content_jp || this.concept.content
        case "en":
          return this.concept.content_en || this.concept.content
        default:
          return this.concept.content
      }
    },

    goReserve: _.debounce(function () {
      console.log("goReserve")
      // 예약하기 화면으로 이동 - conceptId를 쿼리 파라미터로 전달
      this.$router.push({
        path: "/booking/reserve",
        query: {
          conceptId: this.$route.params.conceptId,
        },
      })
    }, 500),
  },
}
</script>
<style scoped>
.v-tab--active {
  color: black;
}
.title {
  border-bottom: 3px solid #8d75cb;
  height: 40px;
}

.reviewBtn {
  background-color: #9a80d1 !important;
  color: white !important;
  font-weight: 500;
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 17px !important;
  border: 1px solid grey;
  border-radius: 6px;
}

.bottomFixedButton {
  max-width: 580px;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0px;
  padding-bottom: 10px;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.floating-reserve-btn {
  z-index: 100;
  margin-bottom: 40px;
  margin-right: 16px;
  font-weight: 600;
  font-size: 16px;
  padding: 0 24px !important;
  height: 56px !important;
}

/* 580px 이상 화면에서 중앙 정렬된 영역 내에 버튼 배치 */
@media (min-width: 580px) {
  .floating-reserve-btn {
    right: calc(50% - 290px + 16px) !important;
  }
}
</style>
